import { useState } from 'react';

const useLayoutPlan = () => {
  const [explorePlacesVisible, setExplorePlacesVisible] = useState<boolean>(false);
  const [favoritesVisible, setFavoritesVisible] = useState<boolean>(false);
  const [yourBookingsVisible, setYourBookingsVisible] = useState<boolean>(false);
  const [localExperiencesVisible, setLocalExperiencesVisible] = useState<boolean>(false);
  const [showTourInfoModal, setShowTourInfoModal] = useState<boolean>(false);

  return {
    explorePlacesVisible,
    setExplorePlacesVisible,
    favoritesVisible,
    setFavoritesVisible,
    yourBookingsVisible,
    setYourBookingsVisible,
    localExperiencesVisible,
    setLocalExperiencesVisible,
    showTourInfoModal,
    setShowTourInfoModal,
  };
};

export default useLayoutPlan;
